module.exports = __webpack_public_path__ + "005d3e83483c23fbf60e0cd0d5ad560a.svg";